// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"7b61d2d9d0019b302ed0","339":"770f9f77ba77cd048ff7"}[chunkId] + ".js";
};